import React from "react";
import { Link } from "react-router-dom";
import "./Sitemap.scss";

const SITEMAP_SECTIONS = [
  {
    heading: "Main",
    links: [
      { label: "Home", to: "/" },
      { label: "About Us", to: "/about" },
      { label: "Platform Overview", to: "/platform-overview" },
      { label: "Contact Us", to: "/contact" },
      { label: "API Catalogue", to: "/api-catalogue-home" },
    ],
  },
  {
    heading: "Pricing",
    links: [
      { label: "Pricing Plans", to: "/pricing" },
      { label: "Enterprise Request", to: "/pricing/enterprise-request" },
    ],
  },
  {
    heading: "Products",
    links: [
      { label: "All Products", to: "/products" },
      { label: "DokGen AI", to: "/products/dokgen-ai" },
      { label: "VerifyX", to: "/products/verifyx" },
      { label: "Legal AI", to: "/products/legal-ai" },
      { label: "Live Tracker", to: "/products/live-tracker" },
      { label: "Billing AI", to: "/products/billing-ai" },
      { label: "Email To Case", to: "/products/email-to-case" },
      { label: "VPD AI", to: "/products/vpd-ai" },
    ],
  },
  {
    heading: "Account",
    links: [
      { label: "Sign In", to: "/login" },
      { label: "Sign Up", to: "/signup" },
      { label: "Forgot Password", to: "/forgot-password" },
    ],
  },
  {
    heading: "Legal",
    links: [{ label: "Privacy Policy", to: "/privacy-policy" }],
  },
];

const Sitemap = () => {
  return (
    <div className="sitemap-page">
      <div className="sitemap-page__hero">
        <h1 className="sitemap-page__title">Sitemap</h1>
        <p className="sitemap-page__subtitle">
          A complete overview of all pages on Doql
        </p>
      </div>

      <div className="sitemap-page__body">
        <div className="sitemap-page__grid">
          {SITEMAP_SECTIONS.map((section) => (
            <div key={section.heading} className="sitemap-page__section">
              <h2 className="sitemap-page__section-heading">
                {section.heading}
              </h2>
              <ul className="sitemap-page__list">
                {section.links.map((link) => (
                  <li key={link.to} className="sitemap-page__item">
                    <Link to={link.to} className="sitemap-page__link">
                      <span className="sitemap-page__arrow" aria-hidden="true">
                        ›
                      </span>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Sitemap;
